/**
 * Wait-for cards. A ring brings you back and asks. Only Fulfilled
 * opens cards connected after this one.
 */

export const WAIT_NODE_TYPE = 'wait';
export const OPEN_WAIT_REMINDER = 'fokus:open-wait-reminder';

export const WAIT_FOR_KINDS = [
  { id: 'email', label: 'E-mail' },
  { id: 'message', label: 'Message' },
  { id: 'call', label: 'Call' },
  { id: 'meeting', label: 'Meeting' },
  { id: 'approval', label: 'Approval' },
  { id: 'delivery', label: 'Delivery' },
  { id: 'payment', label: 'Payment' },
  { id: 'other', label: 'Other' },
];

const KIND_IDS = new Set(WAIT_FOR_KINDS.map((kind) => kind.id));
const DETAILS_MAX = 500;

export function isWaitNode(task) {
  return task?.nodeType === WAIT_NODE_TYPE;
}

export function isWaitFulfilled(task) {
  return isWaitNode(task) && Boolean(task.fulfilledAt);
}

export function normalizeWaitFor(value) {
  return KIND_IDS.has(value) ? value : 'email';
}

export function waitKindLabel(value) {
  const id = normalizeWaitFor(value);
  return WAIT_FOR_KINDS.find((kind) => kind.id === id)?.label || 'E-mail';
}

export function defaultWaitTitle(value) {
  return `Wait for ${waitKindLabel(value).toLowerCase()}`;
}

export function isDefaultWaitTitle(name) {
  const text = String(name || '').trim().toLowerCase();
  if (!text) return true;
  return WAIT_FOR_KINDS.some((kind) => text === `wait for ${kind.label.toLowerCase()}`);
}

export function normalizeWaitDetails(value) {
  if (value == null) return '';
  return String(value).replace(/\s+/g, ' ').trim().slice(0, DETAILS_MAX);
}
